import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'
import { FieldValue } from 'react-hook-form'

import { Theme } from '../../types/theme'
import { themeDependentCss } from './themeDependentCss'

interface DateInputWrapperProps {
  disabled?: boolean
  flex?: number
  error?: FieldValue<Error>
}

export const DateInputWrapper = styled.div<DateInputWrapperProps>`
  display: flex;
  position: relative;
  ${({ flex }) => flex && flex};

  ${({ theme }) => themeDependentCss(theme as Theme)}

  ${({ disabled, error }) =>
    !disabled &&
    !error &&
    `&:hover {
      input[type='text']:not(:focus) {
        border-color: ${Color.Black};
      }
  }`}
`

interface CalendarButtonProps {
  disabled?: boolean
}

export const CalendarButton = styled.div<CalendarButtonProps>`
  display: flex;
  opacity: 1;
  align-items: center;
  width: 50px;
  height: 50px;
  padding: ${Spacing.S8} ${Spacing.S12};
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  cursor: pointer;

  ${({ disabled }) => disabled && `cursor: not-allowed; opacity: 0.5;`};
`

export const CalendarHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${Spacing.S4} ${Spacing.S6};
  border-bottom: 1px solid ${Color.Grey200};
  overflow: hidden;
`

export const MonthHeader = styled(CalendarHeaderContainer)`
  flex: 1;
  border-right: 1px solid ${Color.Grey200};
`
